(ns util.transform
  (:require
   #?@(:clj [[clj-time.coerce :as dtc]
             [clj-time.core :as dt]
             [inflections.core :as inflections]]
       :cljs [[cljs-time.coerce :as dtc]])
   [util.string :as str]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud])
  #?(:clj
     (:import
      (java.sql Timestamp)
      (java.util Date)
      (org.joda.time DateTime))))


(defn todecimal [text & [default]]
  (cond
    (nil? text)
    (or default 0.0)

    (string? text)
    #?(:clj
       (try
         (if (= text "NaN")
           0.0
           (Double/parseDouble (str/replace text #"," ".")))
         (catch Exception _ (or default 0)))
       :cljs
       (try
         (let [v (js/parseFloat text)]
           (if (= v js/NaN) 0 v))
         (catch js/Error _ (or default 0))))


    (char? text)
    (recur (str text) default)

    (number? text)
    (double text)

    :else (or default 0)))

(defn tonumber [text & [default]]
  (cond
    (nil? text)
    (or default 0)

    (string? text)
    #?(:clj
       (if (or (not (u/presence text)) (= text "NaN"))
         0
         (try
           (Long/parseLong text)
           (catch NumberFormatException e
             (todecimal text default))))
       ;TODO this does not work for strings that aren't numbers or blank.
       :cljs
       (if (u/presence text)
         (js/parseInt text)
         0))

    (char? text)
    (recur (str text) default)

    (number? text)
    text

    :else (or default 0)))

(defn find-number [text]
  (tonumber (re-find #"[\d]+" text)))

(defn tobit [text]
  (if
    (= 0
      (cond
        (string? text) (tonumber text)
        (number? text) text
        :else 0))
    0 1))

(defn toboolean [text]
  (cond
    (nil? text) false
    (false? text) false
    (= \0 text) false
    (and (number? text) (zero? text)) false

    (and (string? text)
      (#{"NaN" "" "0" "false"} (str/lower-case (str/trim text)))) false

    :else true))

(defn tomass [text]
  (u/round (* 1000 (double (tonumber text)))))

(defn frommass [text]
  (/ (double (tonumber text)) 1000))

(defn tomm [text]
  (u/round (* 10 (double (tonumber text)))))

(defn frommm [text]
  (/ (double (tonumber text)) 10))

(defmulti totimestamp
  (fn [t]
    (cond
      (string? t) :string
      (number? t) :number
      :else
      #?(:clj  (class t)
         :cljs :coerce))))

(defmethod totimestamp :string [texttime]
  "Makes a sql timestamp out of a string : yyyy-MM-dd hh:mm:ss"
  (if-let [date (ud/parse-date (u/presence texttime))]
    (ud/sqltime date)
    (try
      (totimestamp
        #?(:clj (Long/parseLong texttime)
           :cljs (js/parseInt texttime)))
      (catch #?(:clj Exception :cljs js/Error) _ nil))))

(defmethod totimestamp :number [time]
  ;; Do a best guess check to see if it's a seconds since epoch time
  ;; instead of millisecond time.
  (cond
    (= time 0) nil
    (< time 10000000000)
    #?(:clj (Timestamp. (* time 1000))
       :cljs (dtc/from-long (* time 1000)))
    :else
    #?(:clj (Timestamp. time)
       :cljs (dtc/from-long time))))

(defmethod totimestamp :coerce [time]
  #?(:clj  (Timestamp. (.getTime (dtc/to-date time)))
     :cljs (dtc/to-date time)))

#?(:clj
   (defmethod totimestamp Timestamp [time] time))

#?(:clj
   (defmethod totimestamp Date [time]
     (Timestamp. (.getTime time))))

#?(:clj
   (defmethod totimestamp DateTime [time]
     (Timestamp. (.getMillis time))))

#?(:clj
   (defmethod totimestamp Integer [time]
     (totimestamp (long time))))

(defmethod totimestamp :default [time]
  nil)

(defn tocurrency [text]
  (let [n (tonumber text)]
    (cond
      n (Math/round (* n 100.0))
      :else 0)))

(defn topercentage [text]
  (let [n (tonumber text)]
    (cond
      n (/ n 100.0)
      :else 0)))

(defn fromcurrency [text]
  (let [n (tonumber text)]
    (cond
      n (/ (double n) 100)
      :else 0)))

(defn update-many
  "Apply `f` to values at `keys` in `hsh`, for the keys that are present."
  [hsh keys f]
  (reduce #(if (contains? %1 %2) (update %1 %2 f) %1) hsh keys))

(defn applyfields
  "See `update-many`. Takes function, then data, then keys."
  [f hsh keys]
  (update-many hsh keys f))

(defn applyobj-fields
  "See `update-many`. Takes data, then function, then keys."
  [hsh f keys]
  (update-many hsh keys f))

(defn status-text [statusarray index]
  (get statusarray (Math/abs (long (if (string? index) (tonumber index) index)))))

(defn human-readable-time [date-stamp {:keys [formatted?] :or {formatted? false}}]
  #?(:clj
     (let [now (dt/now)
           seconds (when date-stamp (dt/in-seconds (dt/interval date-stamp now)))
           minutes (when date-stamp (dt/in-minutes (dt/interval date-stamp now)))
           hours (when date-stamp (dt/in-hours (dt/interval date-stamp now)))
           days (when date-stamp (dt/in-days (dt/interval date-stamp now)))
           weeks (when date-stamp (dt/in-weeks (dt/interval date-stamp now)))
           months (when date-stamp (dt/in-months (dt/interval date-stamp now)))
           years (when date-stamp (dt/in-years (dt/interval date-stamp now)))
           result
           (cond
             (and years (>= years 1))
             (if formatted? (inflections/pluralize years "year") {:duration years :type (inflections/pluralize years "year")})

             (and months (>= months 1))
             (if formatted? (inflections/pluralize months "month") {:duration months :type (inflections/pluralize months "month")})

             (and weeks (>= weeks 1))
             (if formatted? (inflections/pluralize weeks "week") {:duration weeks :type (inflections/pluralize weeks "week")})

             (and days (>= days 1))
             (if formatted? (inflections/pluralize days "day") {:duration days :type (inflections/pluralize days "day")})

             (and hours (>= hours 1))
             (if formatted? (inflections/pluralize hours "hour") {:duration hours :type (inflections/pluralize hours "hour")})

             (and minutes (>= minutes 1))
             (if formatted? (inflections/pluralize minutes "minute") {:duration minutes :type (inflections/pluralize minutes "minute")})

             (and seconds (>= seconds 1))
             (if formatted? (inflections/pluralize seconds "second") {:duration seconds :type (inflections/pluralize seconds "second")})

             :else
             (if formatted? "Never" {:duration nil :type "Never"}))]
       result)))